(ns ui.table-widths
  "Column widths for a resizable `table-fixed` table, persisted in localStorage.
   Kept out of the view so it can be exercised without one.")


(defn column-widths
  "column-id -> pixel width for a `table-fixed` table, seeded from `defaults` and
   from whatever the user last dragged (kept under `storage-key`). A plain map:
   the caller owns it and hands it back to `resizable-th` with an `:on-resize`."
  [storage-key defaults]
  (merge defaults
         ;; Unreadable stored widths are not worth failing a table over — and
         ;; "unreadable" includes valid JSON that is not a map, which `merge`
         ;; would throw on from outside the `catch`.
         (let [stored (try
                        (js->clj (js/JSON.parse (js/localStorage.getItem storage-key))
                                 :keywordize-keys true)
                        (catch js/Error _ nil))]
           (when (map? stored)
             (into {} (filter (comp number? val)) stored)))))

(defn clamp-width [width min-width max-width]
  (max min-width (cond-> width max-width (min max-width))))

(defn store-column-widths!
  "Persist what `column-widths` will read back."
  [storage-key widths]
  ;; Can throw on a full quota or in Safari's private mode, at the end of a drag.
  (try
    (js/localStorage.setItem storage-key (js/JSON.stringify (clj->js widths)))
    (catch js/Error _ nil)))
